import React, { useState, useEffect } from 'react';
import Loader from '../../../components/Loader/Loader';
import { formatUrl, handleZoom, isGlobalEnv } from '../../../libs/helper/HelperFunctions';
import {
  IVisitedPagePayload,
  SectionType,
  TrafficAnalyticsActions,
} from '../../../libs/store/actions/WebAnalytics/TrafficAnalyticsActions';
import { useDispatch } from 'react-redux';
import { IProduct } from '../../../libs/models/cbo/EngagementModels';
import { useAppSelector, IApplicationState } from '../../../libs/store/reducers';
import { storage, STORAGE_CONSTANTS } from '../../../libs/services/LocalStorage';
import { routes } from '../../../navigation/Routes';
import { getTrueNorthCodeDiscoveryAuthUrl } from '../../CBOLogin/CBOLoginConstants';

interface IAssetProps {
  url?: string;
  selectedAssetConfig?: IProduct;
  isEngagement?: boolean;
  selectedEnagagementName?: string;
  selectedEnagagementId?: string;
  selectedClientName?: string;
}

const InnowakeDiscoveryDashboard = ({
  isEngagement,
  selectedAssetConfig,
  selectedEnagagementName,
  selectedEnagagementId,
  selectedClientName,
}: IAssetProps) => {
  const dispatch = useDispatch();
  const [showAsset, setshowAsset] = useState<boolean>(false);

  const dispatcher = {
    postPageVisited: (data: IVisitedPagePayload) =>
      dispatch(TrafficAnalyticsActions.postVisitedPageStart(data)),
  };
  const { selectedPhase, KeyAssetDefaultList } = useAppSelector((state: IApplicationState) => ({
    KeyAssetDefaultList: state.engagement.KeyAssetDefaultList,
    selectedPhase: state.cboViewSummary.selectedPhase,
  }));
  const selectedAssetConfigDefault = KeyAssetDefaultList?.find(
    (keyAsset) => keyAsset.product?.toLowerCase() === selectedAssetConfig?.product.toLowerCase(),
  );

  const handleAssessConfig = () => {
    const authUrl = getTrueNorthCodeDiscoveryAuthUrl(
      selectedAssetConfig?.configDone
        ? formatUrl(selectedAssetConfig?.authDomainUrl ?? '')
        : formatUrl(selectedAssetConfigDefault?.authDomainUrl ?? ''),
      selectedAssetConfig?.configDone
        ? selectedAssetConfig?.realm
        : selectedAssetConfigDefault?.realm,
    );
    const path =
      window.location?.pathname == routes.cboEngagementSummary
        ? `${window.location?.pathname}#${selectedPhase}`
        : window.location?.pathname;
    storage.setItem(STORAGE_CONSTANTS.authOriginatorUrl, path);
    window.location.href = authUrl;
  };
  const initialCheck = () => {
    const isAuthenticated: any = isEngagement
      ? storage.getItemSession(STORAGE_CONSTANTS.codeDiscoveryEngAuthenticated)
      : storage.getItemSession(STORAGE_CONSTANTS.codeDiscoveryAuthenticated);
    if (isAuthenticated == 'true') {
      setshowAsset(true);
    } else {
      setshowAsset(false);
      handleAssessConfig();
    }
  };

  useEffect(() => {
    initialCheck();
    handleZoom('assess-iframe');
    dispatcher.postPageVisited({
      sectionType: isEngagement ? SectionType.ENG_ASSET : SectionType.PURSUIT_ASSET,
      assetName: SectionType.TRUNORTH_CODE_DISCOVERY,
      name: selectedEnagagementName,
      id: selectedEnagagementId,
      clientName: selectedClientName,
    });
    return () => {
      dispatcher.postPageVisited({
        sectionType: isEngagement ? SectionType.ENG_ASSET : SectionType.PURSUIT_ASSET,
        assetName: SectionType.TRUNORTH_CODE_DISCOVERY,
        name: selectedEnagagementName,
        id: selectedEnagagementId,
        clientName: selectedClientName,
      });
      isEngagement
        ? storage.removeSessionItem(STORAGE_CONSTANTS.codeDiscoveryEngAuthenticated)
        : storage.removeSessionItem(STORAGE_CONSTANTS.codeDiscoveryAuthenticated);
    };
  }, []);

  const getIframeUrl = (instanceUrl?: string, projectId?: string) => {
    return `${formatUrl(instanceUrl ?? '')}/#/project-${projectId}/dashboard`;
  };

  return (
    <div className="trunorth-dashboard-wrapper">
      <Loader loaderName="Authorizing..." loading={!showAsset}>
        <iframe
          id="assess"
          className="assess-iframe"
          title="Assess"
          src={
            isEngagement
              ? getIframeUrl(selectedAssetConfig?.instanceUrl, selectedAssetConfig?.projectId)
              : selectedAssetConfig?.configDone
                ? getIframeUrl(selectedAssetConfig?.instanceUrl, selectedAssetConfig?.projectId)
                : getIframeUrl(
                    selectedAssetConfigDefault?.instanceUrl,
                    selectedAssetConfigDefault?.projectId,
                  )
          }
          onLoad={() => setshowAsset(true)}
        />
      </Loader>
    </div>
  );
};

export default InnowakeDiscoveryDashboard;
